import { Button, Group, Stack, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

import { transformValues } from '../../../../lib/utils';
import { type ActivateTraderRequest } from '../../../../model';
import { initialValues, validate } from '../../lib';
import { TraderRateFields } from '../../../TraderRateFields';

interface ActivationFormProps {
    onSubmit: (values: ActivateTraderRequest) => void;
    traderId: string;
    isLoading?: boolean;
}

export const ActivationForm = ({ onSubmit, traderId, isLoading }: ActivationFormProps) => {
    const form = useForm<ActivateTraderRequest>({
        initialValues: {
            traderId: {
                value: traderId,
            },
            traderName: {
                value: '',
            },
            ...initialValues,
        },
        transformValues,
        validate,
    });

    return (
        <form
            onSubmit={form.onSubmit((v) => {
                onSubmit(v);
                form.resetDirty();
            })}
        >
            <Stack>
                <TextInput
                    label='Имя трейдера'
                    placeholder='Введите имя'
                    {...form.getInputProps('traderName.value')}
                />

                <TraderRateFields
                    commissionInputProps={form.getInputProps('commission.value')}
                    calculationRuleInputProps={form.getInputProps('calculationRules')}
                    disabled={isLoading}
                />

                <Group justify='space-between'>
                    <Button
                        fullWidth
                        type='submit'
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        Активировать
                    </Button>
                </Group>
            </Stack>
        </form>
    );
};
